import { useState } from "react";
import i18n from "../Traduccion_ES_EN/i18nMiCuenta";
import Select from "../components/atoms/Select";

function ButtonTranslation() {
  const defaultLang = sessionStorage.getItem("lang") || "es";

  const [selectLanguage, setSelectLanguage] = useState(defaultLang);

  i18n.changeLanguage(defaultLang);

  const chooseLanguage = (e) => {
    e.preventDefault();
    i18n.changeLanguage(e.target.value);
    setSelectLanguage(e.target.value);
    sessionStorage.setItem("lang", e.target.value);
  };

  const eua = "../../public/EUAicon.png";
  const mxn = "../../public/MEXicon.png";

  return (
    <>
      <Select
        options={[
          {
            name: "Español",
            value: "es",
            image: "https://img.icons8.com/color/48/mexico.png",
          },
          {
            name: "English",
            value: "en",
            image: "https://img.icons8.com/color/48/usa.png",
          },
        ]}
        valueSelect="value"
        value={selectLanguage}
        onChange={chooseLanguage}
        renderOption={(option) => (
          <div>
            <img src={option.image} alt={option.name} />
            {option.name}
          </div>
        )}
      />
    </>
  );
}

export default ButtonTranslation;

/*
<img width="48" height="48" src="https://img.icons8.com/color/48/mexico.png" alt="mexico"/>
<img width="48" height="48" src="https://img.icons8.com/color/48/usa.png" alt="usa"/>
*/
